var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"confirmation"}},[_c('h2',[_vm._v("Confirmar pasar a "+_vm._s(_vm.to)+"?")])])}
var staticRenderFns = []

export { render, staticRenderFns }